<template>
  <img :src="$page.props.logo" alt="logo">
</template>
